/* global document */

import React, { useEffect } from "react"
import PropTypes from "prop-types"

function loadScript(src) {
  const script = document.createElement("script")
  script.src = src
  script.crossOrigin = "anonymous"
  document.body.appendChild(script)
}

const EfSetTest = (props) => {
  useEffect(() => {
    const listener = () => {
      const userDetails = {}
      if (props.email) userDetails.email = props.email
      if (props.family_name) userDetails.familyName = props.family_name
      if (props.given_name) userDetails.givenName = props.given_name
      if (props.country_code) userDetails.countryCode = props.country_code
      if (props.gender) userDetails.gender = props.gender.toLowerCase()
      if (props.bd_year) userDetails.birthYear = props.bd_year
      window.efset.init(props.integration_id, {
        userId: props.user_id, // required in most journeys
        domElement: "efset", // optional - defaults to "efset"
        languageCode: "en", // optional - defaults to "en"
        userDetails,
      })
    }
    document.addEventListener("efset_loader_ready", listener)
    loadScript("https://app.efset.org/loader.js")
    return () => document.removeEventListener("efset_loader_ready", listener)
  }, [])

  return <div id="efset" style={{ width: "100%" }} />
}

EfSetTest.defaultProps = {
  areaHeight: 600,
}

EfSetTest.propTypes = {
  integration_id: PropTypes.string.isRequired,
  user_id: PropTypes.string.isRequired,
  email: PropTypes.string, // User's unique email address
  country_code: PropTypes.string, // Format: 2-letter ISO code
  gender: PropTypes.string, // Format: "male" or "female"
  bd_year: PropTypes.string, // Format: YYYY
  given_name: PropTypes.string, // Format: example of first name // optional
  family_name: PropTypes.string, // Format: example of last name // optional
}

export default EfSetTest
